<template>
  <div id="app">
    <topbar v-if="isLogged"></topbar>
    <top></top>
    <topmenu></topmenu>
    <div class="content">
        <div class="row columns">
            <div v-if="isFullSizePage === false">
                <div v-if='showLeaguePanel' class="large-1 columns">
                <leaguePanel></leaguePanel>
                </div>
                <div class="large-11 columns" v-bind:class="{ 'large-centered': showLeaguePanel == false }">
                    <router-view></router-view>
                </div>
            </div>
            <div v-else>
                <div class="large-12 columns large-centered">
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import topbar from './components/topbar.vue'
import top from './components/top.vue'
import topmenu from './components/top-menu.vue'
import leaguePanel from './components/league-panel.vue'
import store from './store/index.js'
import { mapGetters } from 'vuex'

export default {
  name: 'app',
  components: {
    topbar,
    topmenu,
    top,
    leaguePanel
  },
  computed:
  {
    ...mapGetters([
      'isLogged',
      'showLeaguePanel',
      'isFullSizePage'
    ])
  },
  created () {
    let tok = localStorage.getItem('key')
    if (tok !== null && tok !== 'undefined') {
      store.dispatch('checkToken')
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.inner-content {
  margin-left : 0;
  margin-right : 0;
}
</style>



// WEBPACK FOOTER //
// App.vue?c39065fe